import { useCallback, useEffect } from "react";

import { AddAddressModal, DuplicateByAddressModal } from "@/domains/point";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { setPointCreatePageModal } from "@/store/slices/ui";
import { PointCreateModal } from "@/types/modals";

import { AddIllegalEntityModal } from "../AddIllegalEntityModal";
import { AddLegalEntityModal } from "../AddLegalEntityModal";
import { AddNetworkModal } from "../AddNetworkModal";
import { DuplicateByIdModal } from "../DuplicateByIdModal";

export const ModalsContainer = () => {
    const dispatch = useAppDispatch();
    const { modal } = useAppSelector((s) => s.ui.pointCreatePage);

    const onClose = useCallback(() => {
        dispatch(setPointCreatePageModal(null));
    }, [dispatch]);

    useEffect(() => {
        dispatch(setPointCreatePageModal(null));
    }, [dispatch]);

    if (!modal) return null;

    switch (modal.type) {
        case PointCreateModal.AddAddress: {
            return (
                <AddAddressModal onClose={onClose} payload={modal.payload} />
            );
        }
        case PointCreateModal.AddContragent: {
            return <AddLegalEntityModal onClose={onClose} />;
        }

        case PointCreateModal.DuplicateByAddress: {
            return (
                <DuplicateByAddressModal
                    onClose={onClose}
                    payload={modal.payload}
                />
            );
        }

        case PointCreateModal.DuplicateById: {
            return (
                <DuplicateByIdModal onClose={onClose} payload={modal.payload} />
            );
        }

        case PointCreateModal.AddNetwork: {
            return <AddNetworkModal onClose={onClose} />;
        }

        case PointCreateModal.AddIllegalContragent: {
            return <AddIllegalEntityModal onClose={onClose} />;
        }
        default:
            return null;
    }
};
